import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "cfmoto-share-slide"
  }, {
    default: _withCtx(() => [$options.shareWechat ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "cfmoto-share-wechat",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.handlerClose && $options.handlerClose(...args), ["stop"]))
    })) : _createCommentVNode("", true)]),
    _: 1
  });
}